<span class="message">
  {{ 'auth.WorkerError.loginPrefix' | translate }}
  <a [href]="url" target="_blank" rel="noopener noreferrer"> {{ vSiteText }}</a>
  {{ 'auth.WorkerError.loginSuffix' | translate }}
</span>
